export default __webpack_public_path__ + "static/media/tablet.218a65d3.svg";